import { findBlocksIn } from 'selectors/block';
import getStore from 'services/getStore';

const store = getStore();

const getActiveBlocks = () => {
  const { blocks, rootBlockId } = store.getState();
  return findBlocksIn(blocks, blocks[rootBlockId], () => true);
};

export default getActiveBlocks;
